import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";
import SearchField from "../../../components/SearchField";
import ActiveInactive from "../../../components/UI/ActiveInactive";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import { constants } from "../../../constants/constants";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import { addlog } from "../../../utils/ApiCalls/Logs";

import { message } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import SelectLocation from "../../../components/LocationFilter";
import ActiveSwitchFile from "../../../components/SwitchFile";
import DeletePop from "../../../constants/ErrorPermissionModal";
import ValidDateUI1 from "../../../constants/ValidDateUI1";
import {
  deleteShortCutsData,
  getShortCutsData,
  updatePosition,
  updateShortCutsData,
} from "../../../utils/ApiCalls/Shortcuts";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import CustomizedDragNDrop from "../../../components/UI/CustomizedDragNDrop";
import { LOG_ACTIONS, LOG_TYPES } from "../../../utils/Constant/LogConstant";

const MySwal = withReactContent(Swal);

const Shortcuts = () => {
  const navigate = useNavigate();
  const params = useParams();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Shortcuts List",
      route: `/shore/ship-shortcuts/${params?.vessel}`,
    },
  ];
  const [active, setActive] = useState("listing");
  const [regionalActive, setRegionalActive] = useState("SG");
  const [rows, setRows] = useState([]);
  const [vessel, setVessel] = useState();
  const [columns, setColumns] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [location, setLocation] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [positionVal, setPositionVal] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [vesselOptions, setVesselOptions] = useState([]);
  
  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      let sort, order;
      sort = options.columnKey;
      order =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined;
      await getData(1, sort, order);
    }
  };

  const setPositionalValue = (data) => {
    const mappedPositionVal = data.map((d) => ({
      id: d.id,
      pos: d.position,
    }));
    setPositionVal(mappedPositionVal);
  };

  useEffect(() => {
    if (vessel?.id) getData(page);
  }, [page, pageSize, search, vessel]);

  useEffect(() => {
    getData(page);
  }, [regionalActive]);
  useEffect(() => {
    setColumns([
      {
        title: "Sl",
        width: 30,
        dataIndex: "id",
        key: "id",
        fixed: "left",
        render: (text, record, index) => (page - 1) * pageSize + index + 1,
      },

      {
        title: "Icon",
        width: 100,
        dataIndex: "icon",
        key: "icon",
        render: (image) => (
          <img
            src={`${constants.MEDIAURL}/${image}`}
            style={{ width: "100px", height: "80px" }}
          />
        ),
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) => "",
        width: 50,
        render: (text, record, index) => (
          <p dangerouslySetInnerHTML={{ __html: text }} />
        ),
      },

      {
        title: "Type",
        dataIndex: "type",
        key: "type",
        width: 100,
      },
      {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        width: 100,
        sorter: (a, b) => "",
        render: (item, record, index) => (
          <ActiveSwitchFile
            module={"Shortcuts"}
            item={item}
            record={record}
            index={index}
            handleUpdate={handleUpdate}
          />
        ),
      },

      {
        title: "Action",
        key: "operation",
        width: 100,
        render: (text, record) => (
          <div className="table_action_btn">
            <button className="btn" onClick={() => handleEdit(record.id)}>
              <i
                className="ri-edit-2-line"
                data-toggle="tooltip"
                title="Edit"
              ></i>
            </button>
            <DeletePop
              onConfirm={() =>
                handleDelete(record.id, record.title, record.location_id,record)
              }
            >
              <div>
                {" "}
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </div>
            </DeletePop>
          </div>
        ),
      },
    ]);
  }, [page, pageSize, regionalActive, location, status, search, rows]);
  const getData = async (value, sort, order) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let args = {
      search: search,
      page: value,
      limit: pageSize,
      vessel_id: vessel?.id,
    };
    if (regionalActive) {
      args = { ...args, location: regionalActive };
    }
    if (location && location != -1) {
      args = { ...args, location_id: location };
    }
    if (status !== "") {
      args = { ...args, is_active: status };
    }
    if (order) {
      if (sort) {
        args = { ...args, sort };
      }
      args = { ...args, order };
    }

    let data = await getShortCutsData(args);
    if (data.error) {
      // dispatch({
      //   type: "SET_ERROR_MESSAGE",
      //   errMess: { message: data.error, type: "error" },
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
      setPositionalValue(data.data);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const updateBannerPosition = async (banners) => {
    if (checkPermission(permission, "update_per", "Shortcuts",window?.location?.pathname)) {
      try {
        let args = {
          search: search,
          page: page,
          limit: pageSize,
          vessel_id: vessel?.id,
        };
        if (regionalActive) {
          args = { ...args, location: regionalActive };
        }
        if (status !== "") {
          args = { ...args, is_active: status };
        }

        ;
        const data = await updatePosition(banners, args);
        if (data.error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.error,
          });
        } else if (data.data) {
          setRows(data.data);
          setCount(data.count);
          setPositionalValue(data.data);
          addlog(
          LOG_ACTIONS.UPDATED,
          LOG_TYPES.Shortcuts,
          { location_id: banners[0].location_id , title: `Position updated for Shortcuts` },
          userDetails.id
        );
        }
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } catch (error) {
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Unknown error occurred",
        });
      }
    } else {
      message.error("Update permission missing");
    }
  };
  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Shortcuts",window?.location?.pathname)) {
      navigate(`/shore/ship-shortcuts/${params?.vessel}/edit/` + id);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDelete = async (id, title, location_id,record) => {
    if (checkPermission(permission, "delete_per", "ShortCuts",window?.location?.pathname)) {
      await deleteShortCutsData(id);
      addlog(
        LOG_ACTIONS.REMOVED,
        LOG_TYPES.Shortcuts,
        { id, title: `${record.name}, ${vesselOptions.find(v => v.id === record.vesselId)?.name}`, location_id },
        userDetails.id
      );
      getData(page);
    } else {
      message.error("Missing Permission for delete Shortcuts");
    }
  };

  useEffect(() => {
    getOptionLocation();
  }, [params?.vessel]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getVessels();
    setVesselOptions(data || []);
    if (data.error) {
      // dispatch({
      //   type: "SET_ERROR_MESSAGE",
      //   errMess: { message: data.error, type: "error" },
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else {
      setVessel(
        data?.find(
          (item) =>
            item.name.toLowerCase().replaceAll(" ", "-") === params?.vessel
        )
      );
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const handleUpdate = async (id, values, title, location_id,record) => {
    if (checkPermission(permission, "update_per", "ShortCuts",window?.location?.pathname)) {
      let data = await updateShortCutsData(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          values.is_active === 1 ? LOG_ACTIONS.ACTIVATED : LOG_ACTIONS.DEACTIVATED  ,
          LOG_TYPES.Shortcuts,
          { ...values, id, title : `${record.name}, ${vesselOptions.find(v => v.id === record.vesselId)?.name}`, location_id },
          userDetails.id
        );
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Shortcuts"}>
      <CustomHeaderTitle title={"Shortcuts"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Shortcuts"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Shortcuts List", value: "listing" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Shortcuts List</h5>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                      width: "80%",
                      justifyContent: "flex-end",
                    }}
                  >
                    {regionalActive == "OTHER" && (
                      <SelectLocation
                        getData={getData}
                        setStatus={setLocation}
                        disabled={regionalActive == "OTHER"}
                        status={location}
                        width={200}
                        setPage={setPage}
                      />
                    )}

                    <Link
                      to={`/shore/ship-shortcuts/${params?.vessel}/add`}
                      className="btn add_v_btn"
                    >
                      Add Shortcuts
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div style={{ maxWidth: 200 }}>
                        <SearchField
                          value={search}
                          SearchValue={() => {
                            setPage(1);
                          }}
                          setValue={(e) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <CustomizedDragNDrop
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={
                        regionalActive !== "OTHER"
                          ? columns.filter((c) => c.key !== "location")
                          : columns
                      }
                      rows={rows}
                      title={"Banner"}
                      sortHandler={sortHandler}
                      updatePosition={updateBannerPosition}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "logs" && (
          <Logs
            type={"Shortcuts"}
            slug={"/shore/ship-shortcuts/experience/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default Shortcuts;
